// TODO: Rename this to ConfirmationModal and move to its own directory.
// Also, In order to be fully compliant with DS Modal size type should change from number to 's' | 'm' | 'l'
// and getDSMappedSizeFromValue should be removed
import { Button, Modal } from '@hotjar/hotsauce';
import type { ButtonKind } from '@hotjar/hotsauce/build/components/Button/Button';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { getDSMappedSizeFromValue, MODAL_SIZES } from './modal-sizes';

type OnClickEventType = 'x' | 'cancel' | 'submit';

export interface GenericMessageModalAction {
  onClick: (eventType: OnClickEventType) => void;
  text: string;
  kind?: ButtonKind;
}

export interface GenericMessageModalIcon {
  name: string;
  color?: string;
}

export interface GenericMessageModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  size?: number;
  title?: string;
  description?: string | React.ReactNode;
  submit?: GenericMessageModalAction;
  cancel?: GenericMessageModalAction;
}

/**
 * A Modal composed out of Design System's <Modal /> elements for quickly showing messaging.
 * It can be used to show message prompts and confirmations etc.
 */
export const GenericMessageModal = ({
  size = MODAL_SIZES.medium,
  title,
  description,
  isOpen,
  isLoading,
  submit,
  cancel,
}: GenericMessageModalProps): JSX.Element => {
  const { t } = useTranslationWithPrefix('common:components.modal');

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={title || t('confirmation-message')}
      size={getDSMappedSizeFromValue(size)}
      onClose={cancel?.onClick ? () => cancel?.onClick('x') : undefined}
    >
      {title && <Modal.Header title={title} />}
      <Modal.Body>{description}</Modal.Body>
      {(cancel || submit) && (
        <Modal.Footer>
          {cancel && (
            <Button kind="ghost" onClick={() => cancel.onClick('cancel')}>
              {cancel.text}
            </Button>
          )}
          {submit && (
            <Button
              isLoading={isLoading}
              loadingText={submit.text}
              kind={submit.kind ?? 'primary'}
              onClick={() => submit.onClick('submit')}
            >
              {submit.text}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};
